import { render } from "./NavBar.vue?vue&type=template&id=5fe287ba"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=5fe287ba&lang=scss"
script.render = render

export default script